export default __webpack_public_path__ + "static/media/Mobile_Scroll-2.ea682249.jpg";